import React, { useState, useEffect } from 'react';
import './webviewStyle.css';
import { apiUrlBase } from '../../environment';

const LicenseAgreement = () => {

    const [displayContent, setDisplayContent] = useState('');
    const [title, setTitle] = useState('Climate Mobility Mobile Application License Agreement');
    const [lastModifiedDate, setLastModifiedDate] = useState();
    const [lastModifiedText, setLastModifiedText] = useState('Last Modified');

    useEffect(() => {
        const fetchLicenseAgreement = async () => {
            const url = `${apiUrlBase}/info/pageInfo?page=license`;
            let lang = '';

            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.has('lang')) {
                lang = urlParams.get('lang').trim();
            }
            if (lang == 'es') {
                setTitle('Acuerdo de Licencia de la Aplicación Móvil de Movilidad Climática')
                setLastModifiedText('Última Modificación')
            }
            if (lang == 'hy') {
                setTitle('Կլիմայական Շարժունակության Բջջային Ծրագրի Լիցենզային Համաձայնագիր')
                setLastModifiedText('Վերջին փոփոխություն')
            }

            const options = {
                method: 'GET',
                headers: {
                    'accept': 'application/json',
                    'Authorization': 'Basic Q2l0eUJlZWxpbmVAMjAyNDpDaXR5QkBAbCFuZUAyMDI0'
                }
            };
            if (lang !== '') {
                options.headers['Accept-Language'] = lang;
            }
            try {
                const response = await fetch(url, options);
                if (!response.ok) {
                    throw new Error('Network response was not ok ' + response.statusText);
                }
                const data = await response.json();
                setDisplayContent(data.data);

                let timestamp = parseInt(data?.updated_date);

                let date = new Date(timestamp);
                let formattedDate = `${date.getDate()}th ${date.toLocaleString('default', { month: 'long' })} ${date.getFullYear()}`;
                setLastModifiedDate(formattedDate);

                if (lang === 'es') {
                    const convertTimestampToSpanishDate = timestamp => new Date(timestamp).toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' });
                    setLastModifiedDate(convertTimestampToSpanishDate(timestamp));
                }
                if (lang === 'hy') {
                    const convertTimestampToArmenianDate = timestamp => new Date(timestamp).toLocaleDateString('am-AM', { day: 'numeric', month: 'long', year: 'numeric' });
                    setLastModifiedDate(convertTimestampToArmenianDate(timestamp));
                }

            } catch (error) {
                console.error('There was a problem with the fetch operation:', error);
            }
        };

        fetchLicenseAgreement();
    }, []);

    return (
        <div>
            <div className="logoBeeline">
                <img
                    height={120}
                    alt="logo"
                    src={require('../../assets/images/newfile/Property 1=Variant2 (1).svg').default}
                />
            </div>
            <div className="container">
                <h1 style={{ textAlign: 'center', color: '#442580', fontWeight: 700 }}>
                    {title}
                </h1>
                <div className="horizontalLine"></div>

                <h3>{lastModifiedText}{': '} {lastModifiedDate}</h3>

                <div className="termscontent" dangerouslySetInnerHTML={{ __html: displayContent }} />

            </div>
        </div>
    )
}

export default LicenseAgreement
